export enum DashboardEmbedType {
    QUESTION = "question",
    DASHBOARD = "dashboard",
}

export const COMMON_METABASE_CONFIG = {
    embeds: {
        questions: {},
        dashboards: {
            oneVerifyMain: 136, // ID from metabase
            oneVerifyDemoMain: 152, // ID from metabase
            oneVerifyEraUploadStatus: 145, // ID from metabase
        },
    },
}
